import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client factory.
 *
 * One instance per browser session. Server components should NOT use
 * the shared client - they fetch directly via `openapi-fetch` clients.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // The product is data-dense and long-running. We don't want
        // aggressive refetches on every window focus.
        refetchOnWindowFocus: false,
        // Fail closed - a stale error stays visible until the user retries.
        retry: 1,
        // 30s stale window - long enough to feel responsive on nav,
        // short enough to not mask backend drift.
        staleTime: 30_000,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
